import { TextInput } from "@/components/ui/Field";
import { SegmentedControl } from "@/components/ui/SegmentedControl";
import {
  normalizeAufschlagModus,
  type AufschlagModus,
} from "@/pages/dokumente/documentPricing";

export interface PositionAufschlagValue {
  aufschlag_prozent?: number | null;
  aufschlag_betrag?: number | null;
  aufschlag_modus?: string | null;
}

export function PositionAufschlagFields({
  value,
  disabled,
  onValueChange,
  onModusChange,
  label,
  hint,
}: {
  value: PositionAufschlagValue;
  disabled?: boolean;
  onValueChange: (amount: number) => void;
  onModusChange: (modus: AufschlagModus) => void;
  /** Überschreibt die Beschriftung „Aufschlag %“ / „Aufschlag €“. */
  label?: string;
  /** Hinweis unter dem Feld. Ohne Angabe bleibt der Hinweis zum EK-Aufschlag im Betragsmodus. */
  hint?: string;
}) {
  const modus = normalizeAufschlagModus(value.aufschlag_modus);
  const raw = modus === "betrag" ? value.aufschlag_betrag : value.aufschlag_prozent;
  const amount = raw == null || !Number.isFinite(Number(raw)) ? "" : String(raw);

  return (
    <div className="space-y-1">
      <div className="flex items-end gap-2">
        <div className="min-w-0 flex-1">
          <TextInput
            label={label ?? (modus === "betrag" ? "Aufschlag €" : "Aufschlag %")}
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => onValueChange(e.target.value === "" ? 0 : Number(e.target.value))}
            disabled={disabled}
          />
        </div>
        <SegmentedControl
          className="shrink-0"
          name="Aufschlagart"
          value={modus}
          onChange={onModusChange}
          disabled={disabled}
          options={[
            { value: "prozent", label: "%" },
            { value: "betrag", label: "€" },
          ]}
        />
      </div>
      {hint ? (
        <p className="text-xs text-label-secondary">{hint}</p>
      ) : modus === "betrag" ? (
        <p className="text-xs text-label-secondary">Eurobetrag auf den EK je Einheit.</p>
      ) : null}
    </div>
  );
}
